/** @format */

export const constants = {
    EMAIL_TO: import.meta.env.VITE_EMAIL_TO,
    BASE_URL: import.meta.env.VITE_API_URL ?? "http://localhost:5281",
    FORM_URL: import.meta.env.VITE_FORM_URL,
    MAX_ATTEMPT: parseInt(import.meta.env.VITE_MAX_ATTEMPT),
    VITE_GOOGLE_MAPS_KEY: import.meta.env.VITE_GOOGLE_MAPS_KEY,
    IS_DEBUG: import.meta.env.VITE_IS_DEBUG === "true",
};